import { render, staticRenderFns } from "./ScrollDownSign.vue?vue&type=template&id=740d0d3b&scoped=true&functional=true&"
import script from "./ScrollDownSign.vue?vue&type=script&lang=js&"
export * from "./ScrollDownSign.vue?vue&type=script&lang=js&"
import style0 from "./ScrollDownSign.vue?vue&type=style&index=0&id=740d0d3b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "740d0d3b",
  null
  
)

export default component.exports